import { useDispatch } from "react-redux";
import ContentLayoutHeader from "../../../Common/ContentLayoutHeader";
import { openConfirmationPopup } from "../../../Redux/Actions/PopupActions";
import Container from "@material-ui/core/Container";
import SuperAdminDashboard from "../superAdminDashboard";
import { Form, Formik } from "formik";
import FormikTextField from "../../../Common/FormFields/FormikInputField";
import validationSchema from "../../../Validation/ValidationSchemas";
import { addAvsChannelDetails } from "../../../Redux/Actions/VideoStreamingActions";

const AddAvsDetails = () => {
  const dispatch = useDispatch();
  const handleCancel = () => {
    openConfirmationPopup(dispatch, {
      confirmationPopup: {
        open: true,
        message: "Are You Sure, You Want To Cancel?",
        btnColor: "red",
        btnText: "Yes",
        type: "Create Video Stream Channel",
      },
    });
  };
  return (
    <div className="content-layout add-sectionn p-0 position-relative">
      <Formik
        initialValues={{
          channelName: "",
          streamURL: "",
          ingestEndpoint: "",
          streamKey: "",
        }}
        validationSchema={validationSchema.addIVSDetailsSchema}
        onSubmit={(values) => {
          addAvsChannelDetails(dispatch, values);
        }}
      >
        {(formik) => (
          <Form>
            <SuperAdminDashboard />
            <ContentLayoutHeader
              heading="Add AVS Details"
              handleCancel={handleCancel}
              navigationLink="/website"
              btnText="Add"
              // loading={submitting}
              disabled={!formik.isValid}
            />
            <Container className="mg-top-70 mg-bottom-20">
              <div className="col-12 col-lg-5">
                <div className="white-card">
                  <FormikTextField
                    label="Channel Name"
                    formik={formik}
                    fieldName="channelName"
                    placeholder="Enter Channel Name"
                    labelFontSize="fs-18"
                  />
                  <FormikTextField
                    label="Ingest Endpoint"
                    formik={formik}
                    fieldName="ingestEndpoint"
                    placeholder="Enter Ingest Endpoint"
                    labelFontSize="fs-18"
                  />
                  <FormikTextField
                    label="Stream Key"
                    formik={formik}
                    fieldName="streamKey"
                    placeholder="Enter Stream Key"
                    labelFontSize="fs-18"
                  />
                  <FormikTextField
                    label="Stream URL"
                    formik={formik}
                    fieldName="streamURL"
                    placeholder="Enter Stream URL"
                    labelFontSize="fs-18"
                  />
                </div>
              </div>
            </Container>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default AddAvsDetails;
